module.exports = __webpack_public_path__ + "fonts/SofiaProUltraLight-Italic.a08cb8da.ttf";